// store/modules/call.js
import types from '../mutation-types';
import { CALL_STATUS } from '../../components/widgets/modal/constants';

export const state = {
  // New global unified call state
  unified_call: {
    provider: 'whatsapp',
    callActive: false,
    currentCallId: null,
    callStatus: CALL_STATUS.IDLE,
    callDirection: null, // 'incoming' or 'outgoing'
    isMuted: false,
    audioLevel: 0,
    incomingCall: null, // {call_id, from, provider}
    nextStartTime: 0,
    contact: {
      name: '',
      phone_number: '',
      inbox_id: null,
    },
    evaluationInfo: {
      status: '',
      duration: 0,
    },
    initializedMixingOnce: false,
    isAccepting: false,
    isRejecting: false,
    isAccepted: false,
  },

  unified_ui: {
    callStartTime: null,
    callDuration: 0,
    durationInterval: null,
    ringtoneAudio: null,
  },
};

const getters = {
  // unified call
  getUnifiedCall: _state => _state.unified_call,

  // unified UI
  getUnifiedUI: _state => _state.unified_ui,
};

const actions = {
  // Unified call actions
  updateUnifiedCall({ commit }, payload = {}) {
    commit(types.UPDATE_UNIFIED_CALL, payload);
  },
  resetUnifiedCall({ commit }) {
    commit(types.RESET_UNIFIED_CALL);
  },

  // Unified UI actions
  updateUnifiedUI({ commit }, payload = {}) {
    commit(types.UPDATE_UNIFIED_UI, payload);
  },
  resetUnifiedUI({ commit }) {
    commit(types.RESET_UNIFIED_UI);
  },
};

const mutations = {
  // Unified call mutation
  [types.UPDATE_UNIFIED_CALL](_state, payload) {
    _state.unified_call = { ..._state.unified_call, ...payload };
  },

  [types.RESET_UNIFIED_CALL](_state) {
    _state.unified_call = {
      contact: {
        name: '',
        phone_number: '',
        inbox_id: null,
      },
      evaluationInfo: {
        status: '',
        duration: 0,
      },
      provider: 'whatsapp',
      callActive: false,
      currentCallId: null,
      callStatus: 'idle',
      callDirection: null,
      isMuted: false,
      audioLevel: 0,
      incomingCall: null,
      nextStartTime: 0,
      isAccepting: false,
      isRejecting: false,
      isAccepted: false,
    };
  },

  // Unified UI mutations
  [types.UPDATE_UNIFIED_UI](_state, payload) {
    _state.unified_ui = { ..._state.unified_ui, ...payload };
  },

  [types.RESET_UNIFIED_UI](_state) {
    _state.unified_ui = {
      callStartTime: null,
      callDuration: 0,
      durationInterval: null,
      ringtoneAudio: null,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
